// FLAGS: personal-data, silent-failure
// Opens a chat channel for a client. The only API call in the app that goes out on bare global `axios` instead of
// OpenUpHttpClient — see the member note below.
import axios from "axios";
import { apiPaths } from "@src/constants";

const formatName = (user) =>
  user.lastName ? `${user.firstName} ${user.lastName}` : user.firstName;

// FLAGS: personal-data, silent-failure
// Posts the client's name and id on global `axios`, which this app never configures: no baseURL, so the relative path
// resolves against the dashboard's own origin rather than the API host, and no `withCredentials`, so no session
// cookie. It also bypasses the language, tracing, refresh and App Insights interceptors. The one call site catches
// and shows a snackbar, so the failure looks like a chat feature that does not work rather than a misrouted request.
export const createChat = async (user) => {
  const response = await axios.post(apiPaths.createChat, {
    name: formatName(user),
    is_distinct: true,
    is_public: false,
    is_super: false,
    is_ephemeral: false,
    is_chat_enabled: true,
    client_ids: [user.id],
  });

  return response.data;
};
const service = {
  createChat,
};

export default service;
